import { FormTextarea } from "@/components/forms/FormTextarea";
import { Box, Stack, Button } from '@mui/joy';
import { useFieldArray } from 'react-hook-form';
import Add from '@mui/icons-material/Add';
import { GroupCard } from '@/features/recipes/components/GroupCard';
import { RemoveFormElementButton } from '@/components/RemoveFormElementButton';
import { MIN_INSTRUCTION_GROUPS, MAX_INSTRUCTION_GROUPS, MIN_INSTRUCTIONS, MAX_INSTRUCTIONS, newInstructionGroup, newInstruction } from '@/features/recipes/schema';
import { RoundNumber } from '@/components/RoundNumber';

export function InstructionsFormTab() {
  const { fields, append, remove } = useFieldArray({ name: 'instruction_groups' });  

  return (<>
    <Stack spacing={2}>
      {fields.map((field, index) => (
        <InstructionGroupForm key={field.id} path={`instruction_groups.${index}`} removable={fields.length > MIN_INSTRUCTION_GROUPS} onRemove={() => remove(index)} />                
      ))}      
    </Stack>
    {fields.length < MAX_INSTRUCTION_GROUPS && <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
      <Button startDecorator={<Add />} variant="plain" onClick={() => append(newInstructionGroup())}>Add Instruction Group</Button>
    </Box>}
  </>);
}

function InstructionGroupForm({ path, removable, onRemove }) {  
  const { fields, append, remove } = useFieldArray({ name: `${path}.instructions` });
  return (
    <GroupCard  placeholder="Group Name (e.g. Preparation, Cooking, etc.)" path={path} removable={removable} onRemove={onRemove}>
      <Stack spacing={2}>
        {fields.map((field, index) => (
          <InstructionForm key={field.id} path={`${path}.instructions.${index}`} index={index} removable={fields.length > MIN_INSTRUCTIONS} onRemove={() => remove(index)} />
        ))}
        {fields.length < MAX_INSTRUCTIONS && <Box><Button startDecorator={<Add />} variant="outlined" onClick={() => append(newInstruction())}>Add Instruction</Button></Box>}
      </Stack>
    </GroupCard>
  )
}

function InstructionForm({ path, index, removable, onRemove }) {
  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ xs: 'stretch', sm: 'start' }}>
      <Box sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center' }}>
        <RoundNumber number={index + 1} size="sm" />
      </Box>
      <Stack direction="row" spacing={1} sx={{ width: '100%' }} alignItems="start">
        <FormTextarea name={`${path}.step`} placeholder={`Step ${index + 1}`} sx={{ flexGrow: 1 }} />
        {removable && <RemoveFormElementButton onClick={onRemove} />}
      </Stack>
    </Stack>
  )
}

